import * as actionTypes from "./actionTypes";
import { LOGOUT_USER } from "../user/actionTypes";

const initialState = {
    documentTypeList: { documentTypes: [], total: 0, error: null, loading: false }
};

export default (state = initialState, action) => {
    switch (action.type) {
        case actionTypes.FETCH_DOCUMENT_TYPE:
            return {
                ...state,
                documentTypeList: {
                    ...state.documentTypeList,
                    total: 0,
                    error: null,
                    loading: true
                }
            };

        case actionTypes.FETCH_DOCUMENT_TYPE_SUCCESS:
            return {
                ...state,
                documentTypeList: {
                    documentTypes: action.payload.documentTypes,
                    total: action.payload.total,
                    error: null,
                    loading: false
                }
            };
        case actionTypes.FETCH_DOCUMENT_TYPE_FAILURE:
            return {
                ...state,
                documentTypeList: {
                    documentTypes: [],
                    total: 0,
                    error: action.payload.error,
                    loading: false
                }
            };

        case actionTypes.RESET_DOCUMENT_TYPE:
            return { ...state, documentTypes: initialState.documentTypes };

        case LOGOUT_USER:
            return initialState;

        default:
            return state;
    }
};



// WEBPACK FOOTER //
// ./src/store/document-type/reducer.js